import React, {useEffect, useMemo, useState} from 'react';

import {useParams} from "react-router-dom";

import {useDispatch, useSelector} from "react-redux";

import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import {FillerSection} from "../../components/FillerSection/FillerSection";
import {DynamicFields, fieldTemplateToColumn} from "../../utils/dynamicFields";
import {
    changeTableTemplate,
    getActiveEnvironmentState,
    getTableTemplate,
    loadingActiveEnvironmentState,
    loadTableTemplate
} from "../../redux/reducers/master-of-acts-reducer";
import {getActTemplate, loadingActTemplate} from "../../redux/reducers/act-template-reducer";
import {ActTable} from "../../components/ActTable/ActTable";
import {createColumns} from "../../utils/table";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";


const useStyles = makeStyles(theme => ({
    container: {
        paddingRight: theme.spacing(5),
        paddingLeft: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },
    tableContainer: {
        height: 300,
        width: '100%'
    }
}))

const skanObj = [{
    content: false,
    format: '',
    helperText: '',
    id: 1,
    label: 'Сканы',
    sequenceNumber: 1,
    step: 1,
    type: 'skan',
    variable: 'files',
}]

const fieldTemplateToColumnWithTypes = fieldTemplate => {
    if (fieldTemplate.type === DynamicFields.DATE_TIME_SELECT) {
        return {...fieldTemplateToColumn(fieldTemplate), type: 'date-time'}
    }
    
    return fieldTemplateToColumn(fieldTemplate)
}


const nonTableFieldOffense = (f) => {
    return (!(
            f.type === DynamicFields.CHIP_BLOCK ||
            f.type === DynamicFields.CHECKBOX_FIELD ||
            f.type === DynamicFields.SIGNATURE_FIELD ||
            f.type === DynamicFields.QR_CODE_VIOLATION ||
            f.type === DynamicFields.QR_CODE_FIELD ||
            f.type === DynamicFields.CHECK_LIST ||
            f.type === DynamicFields.SIGNATURE_FOR_TABLE ||
            f.type === DynamicFields.CHART_CONSTRUCTOR||
            f.type === DynamicFields.TABLE_DATE ||
            f.type === DynamicFields.TABLE_MULTILINE ||
            f.type === DynamicFields.TABLE_DATE_TIME ||
            f.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ||
            f.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
            f.type === DynamicFields.SELECTED_OFFENSE_LIST ||
            f.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD
        )   
    )
}

export const TableTemplateEdit = () => {
    const classes = useStyles()

    const {projectID} = useParams()

    const tableTemplate = useSelector(getTableTemplate)
    
    const activeEnvironmentState = useSelector(getActiveEnvironmentState)
    const {actTemplate, loading} = useSelector(getActTemplate)

    const dispatch = useDispatch()

    const options = useMemo(() => {
        
        if (!actTemplate?.fieldTemplates) return []
        
        const OffenseList = actTemplate?.fieldTemplates.filter(f => (f.type === DynamicFields.SELECTED_OFFENSE_LIST) || (f.type === DynamicFields.TABLE_CONSTRUCTOR))

        const OffenseListContent = OffenseList?.map( offense => {
            offense.content.offenseWindow.map( f => {
                return f.father = offense.label
            })
            return offense.content.offenseWindow.filter(f => nonTableFieldOffense(f))
            
        }).flat()



        actTemplate.fieldTemplates = OffenseListContent && [...skanObj, ...actTemplate?.fieldTemplates, ...OffenseListContent]

        const availableColumns = actTemplate?.fieldTemplates?.filter(f =>
            nonTableFieldOffense(f)
        ).map(el => fieldTemplateToColumnWithTypes(el))
        if (tableTemplate?.content?.columns && tableTemplate?.content?.columns?.length !== 0) {
            const fields = availableColumns.map(el => el.field)
            const additionalColumns = tableTemplate?.content?.columns.filter(f => !fields.includes(f.field))
            availableColumns.push(...additionalColumns)
        }
        return availableColumns
    }, [actTemplate])

    const [selectedFieldTemplates, setSelectedFieldTemplates] = useState([])
    const columns = useMemo(() => createColumns(selectedFieldTemplates, false),
        [selectedFieldTemplates]
    
    )
    

    useEffect(() => {
        dispatch(loadingActiveEnvironmentState(projectID))
    }, [projectID])

    useEffect(() => {
        if (activeEnvironmentState && activeEnvironmentState?.act_template) {
            dispatch(loadingActTemplate(activeEnvironmentState.act_template))
        }
    }, [activeEnvironmentState])

    useEffect(() => {
        if (projectID) {
            dispatch(loadTableTemplate(projectID))
        }
    }, [projectID])

    useEffect(() => {
        setSelectedFieldTemplates(tableTemplate?.content?.columns || [])
    }, [tableTemplate])

    const handleSave = () => {
        dispatch(changeTableTemplate({...tableTemplate, content: {...tableTemplate?.content, columns: selectedFieldTemplates}}))
    }



    if (loading || !tableTemplate) return null

    return <Grid container direction={"column"} className={classes.container} spacing={2}>
        <FillerSection title={'Поля таблицы'}>
            <Autocomplete
                value={selectedFieldTemplates}
                multiple
                fullWidth
                onChange={(_, newValue) => setSelectedFieldTemplates(newValue)}
                options={options}
                getOptionLabel={(option) => option.onion === 1 ? option.headerName : option.father + ' --> ' + option.headerName}
                getOptionSelected={(option, value) => option.field === value.field}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant={'outlined'}
                        size={'small'}
                    />
                )}
            />
        </FillerSection>
        <FillerSection title={'Предпросмотр'}>
            <div className={classes.tableContainer}>
                <ActTable columns={columns} rows={[]}/>

            </div>
        </FillerSection>
        <Grid item container justifyContent={'flex-start'}>
            <Grid item>
                <Button onClick={handleSave}
                        variant={"contained"}
                        size={"small"}>
                    <Typography variant={'inherit'}>
                        Сохранить
                    </Typography>
                </Button>
            </Grid>
        </Grid>
    </Grid>
}